export { default as FormatPageInputTracker } from "./FormatPageInputTracker.vue";
export { default as FormatPageObjectsSelector } from "./FormatPageObjectsSelector.vue";
export { default as FormatPageObjectDragTracker } from "./FormatPageObjectDragTracker.vue";
export { default as FormatPageLocator } from "./FormatPageLocator.vue";
export { default as QuestionnaireFormatPageInputTracker } from "./QuestionnaireFormatPageInputTracker.vue";
export { default as QuestionnaireFormatPageObjectsSelector } from "./QuestionnaireFormatPageObjectsSelector.vue";
export { default as QuestionnaireFormatPageLocator } from "./QuestionnaireFormatPageLocator.vue";
export { default as QuestionnaireFormatPageRelocator } from "./QuestionnaireFormatPageRelocator.vue";
export * from "./IFormatPageLocatable";
